export enum StatusTagThemes {
    DEFAULT = 'default',
    DARK = 'dark',
    UNITE = 'unite',
    JOIN_FLOW = 'join-flow'
}
